import { gql } from 'graphql-tag'

export default gql`
  fragment ModuleTerminalConnectivitySpecsFragment on ModuleTerminalConnectivitySpecs {
    ethernet
    connectivity4G
    wifi
    bluetooth
  }
`
